// This registry lives in the importing JavaScript realm. Content scripts keep
// it in Chrome's isolated world; no root or private state is put on the page.
const roots = new WeakMap();
export function registerUiShadowRoot(host, root) {
    roots.set(host, root);
    return () => { if (roots.get(host) === root)
        roots.delete(host); };
}
export function getUiShadowRoot(host) {
    return host ? roots.get(host) ?? host.shadowRoot : null;
}
export function getUiActiveElement(root = document) {
    let active = root.activeElement;
    while (active) {
        const child = getUiShadowRoot(active)?.activeElement;
        if (!child)
            break;
        active = child;
    }
    return active;
}
/** Observe inside events where a closed root exposes their real path, plus
 * outside events on its document. Each event reaches the callback once. */
export function listenInOwnerDocument(owner, type, listener, options) {
    const root = owner.getRootNode();
    const doc = owner.nodeType === 9 ? owner : owner.ownerDocument;
    const shadow = root.nodeType === 11 && 'host' in root ? root : null;
    const callback = listener;
    const outside = event => {
        if (shadow && event.composedPath().includes(shadow.host))
            return;
        callback(event);
    };
    shadow?.addEventListener(type, callback, options);
    doc.addEventListener(type, outside, options);
    return () => {
        shadow?.removeEventListener(type, callback, options);
        doc.removeEventListener(type, outside, options);
    };
}
// Shared UI defaults to its owning web document. The extension binds that
// document to its isolated bus before any shared controls mount.
const documentEvents = new WeakMap();
export function registerUiDocumentEvents(doc, target) {
    documentEvents.set(doc, target);
}
export function getUiEventTarget(doc = document) {
    return documentEvents.get(doc) ?? doc.defaultView ?? doc;
}
//# sourceMappingURL=shadowDom.js.map